import { getDisyNamespace } from '@disy/lib/disy';
import { cadenzaLocalStorage } from '@disy/lib/storage';

import { cadenzaSessionStorage } from './storage';

const ITEM_SESSIONID = 'clientSessionId';

/**
 * Method to call when Cadenza Web base is loaded: Clears the sessionStorage and localStorage.
 */
export function initializeCadenzaStorage() {
  const clientSessionId = getDisyNamespace().clientSessionId!;

  if (cadenzaLocalStorage.getItem(ITEM_SESSIONID) !== clientSessionId) {
    cadenzaLocalStorage.clear();
    cadenzaLocalStorage.setItem(ITEM_SESSIONID, clientSessionId);
  }

  if (cadenzaSessionStorage.getItem(ITEM_SESSIONID) !== clientSessionId) {
    cadenzaSessionStorage.clear();
    cadenzaSessionStorage.setItem(ITEM_SESSIONID, clientSessionId);
  }
}
